import { HeroSection } from '@/components/sections/HeroSection';
import { ServicesSection } from '@/components/sections/ServicesSection';
import { ArtistSection } from '@/components/sections/ArtistSection';
import { YouTubeShowcase } from '@/components/sections/YouTubeShowcase';
import { GallerySection } from '@/components/sections/GallerySection';
import { TestimonialsSection } from '@/components/sections/TestimonialsSection';
import { CTASection } from '@/components/sections/CTASection';

const HomePage = () => {
    return (
        <main>
            <HeroSection />
            <ServicesSection />
            <ArtistSection />
            <YouTubeShowcase />
            <GallerySection />
            <TestimonialsSection />
            <CTASection />
        </main>
    );
};

export default HomePage;
